<template>
  <div>
    <h1 style="text-align: center">Option Management</h1>
    <v-card class="text-xs-center">
      <OptionTable />
    </v-card>
  </div>
</template>

<script>
import OptionTable from "@/components/back-office/InStore/ProductManagement/OptionManagement/OptionTable.vue";
import { mapMutations } from "vuex";

export default {
  components: {
    OptionTable,
  },
  methods: {
    ...mapMutations({
      setStoreNameAndDetailId: "storeBack/setStoreNameAndDetailId",
    }),
  },

  created() {
    this.setStoreNameAndDetailId({
      name: this.$route.params.store_name,
      id: this.$route.params.store_id,
    });
  },
};
</script>

<style></style>
